import * as actionTypes from './actionTypes'
import menuService from 'services/menuService'
import orderService from 'services/orderService'
import googleAnalyticsUtils from 'utils/googleAnalytics'

export const logoutRequest = () => {
  return dispatch => {
    menuService
      .logout()
      .then(function (data) {
        dispatch(logoutSuccess())
        localStorage.removeItem("country");
      })
      .catch(function (error) {
        if(error.response.status === 401){
          dispatch(logoutSuccess())
        }
      })
  }
}

export const fetchingListAddressForOrder = email => {
  return dispatch => {
    menuService
      .getListAddressToDelivery(email)
      .then(function (addresses) {
        if(addresses.length === 1 ){
          dispatch(selectAddressForOrder(addresses))
        }
        dispatch(requestSuccessListAddressToDelivery(addresses))
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const fetchingRecentlyOrdered = idAddress => {
  return dispatch => {
    dispatch(startRecentlyOrderRequest())
    menuService
      .getRecentlyOrdered(idAddress)
      .then(function (data) {
        dispatch(finishRecentlyOrderRequest())
        dispatch(fetchingRecentlyOrderedSuccess(data))
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const fetchingPendingOrderFeedback = idAddress => {
  return dispatch => {
    orderService
      .getPendingFeedback(idAddress)
      .then(function (data) {
        if (data && data.previousOrderId) {
          googleAnalyticsUtils.sendEvent('feedback_card_viewed', String(data.previousOrderId))
          dispatch(orderFeedbackPendingSuccess(data))
        } else {
          dispatch(orderFeedbackClear())
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const submitOrderFeedback = payload => {
  return dispatch => {
    orderService
      .submitFeedback(payload)
      .then(function () {
        googleAnalyticsUtils.sendEvent('feedback_submitted', String(payload.previousOrderId))
        dispatch(orderFeedbackSubmitted())
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const skipOrderFeedback = payload => {
  return dispatch => {
    orderService
      .skipFeedback(payload)
      .then(function () {
        googleAnalyticsUtils.sendEvent('feedback_skipped', String(payload.previousOrderId))
        dispatch(orderFeedbackSkipped())
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const fetchingMenu = (idBusiness, idAddress) => {
  return dispatch => {
    menuService
      .fetchingMenu(idBusiness, idAddress)
      .then(function (data) {
        dispatch(fetchingMenuSuccess(data))
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const selectItemSideBarMenu = itemsSideBar => {
  return {
    type: actionTypes.SELECT_ITEM_SIDE_BAR_MENU,
    itemsSideBar: itemsSideBar,
  }
}

export const changeMenuTitleHeader = titleHeader => {
  return {
    type: actionTypes.MENU_CHANGE_TITLE_HEADER,
    titleHeader: titleHeader
  }
}

export const verifyRestaurantAvailable = (idRestaurant, idBusiness) =>{
  return dispatch => {
    menuService
    .verifyRestaurantAvailable(idRestaurant, idBusiness)
    .then(function(data){
      dispatch(verifyRestaurantAvailableSuccessful(data))
    })
  }
}

const verifyRestaurantAvailableSuccessful = payload =>{
  return {
    type: actionTypes.MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL,
    payload : payload
  }
}

export const closeModalAvailableRestaurant = () =>{
  return {
    type: actionTypes.MENU_REMOVE_RESTAURANT_NOT_AVAILABLE
  }
}

export const fetchingProducts = (idRestaurant, idCategory, idProduct) => {
  return dispatch => {
    dispatch(settingActiveCategory(idCategory))
    menuService
      .getProducts(idRestaurant, idCategory, idProduct)
      .then(function (data) {
        dispatch(fetchingProductsSuccess(data))
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const fetchingMealOptionsFromPopularDish = payload => {
  return dispatch => {
    menuService
      .getCategoryFromProduct(payload.product, payload.business.id)
      .then(function (data) {
        if (data.length > 0 && data[0].mealOptions.length > 0) {
          let productSelected = {
            ...data[0],
            businessName: payload.product.businessName,
            businessId: payload.business.businessId,
            currency: payload.business.currency,
          }

          dispatch(selectProduct(productSelected))
        } else {
          dispatch(addProductToCart(payload))
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export const changeRestaurantOptions = idRestaurantsOptions => {
  return {
    type: actionTypes.CHANGE_RESTAURANT_OPTIONS,
    idRestaurantsOptions: idRestaurantsOptions,
  }
}

export const restaurantSelected = restaurant => {
  return {
    type: actionTypes.RESTAURANT_SELECTED,
    restaurant: restaurant
  }
}

export const categoriesSelected = categoriesRestaurant => {
  return {
    type: actionTypes.CATEGORIES_SELECTED,
    categoriesRestaurant: categoriesRestaurant,
  }
}

export const settingActiveCategory = idCategory => {
  return {
    type: actionTypes.SETTING_ACTIVE_CATEGORY,
    idActiveCategory: idCategory,
  }
}

export const deleteRestaurantSelected = () => {
  return {
    type: actionTypes.DELETE_RESTAURANT_SELECTED,
  }
}

export const selectProduct = product => {
  return {
    type: actionTypes.SELECT_PRODUCT,
    productSelected: product,
  }
}

export const closeProductDetails = () => {
  return {
    type: actionTypes.CLOSE_PRODUCT_DETAILS,
  }
}

export const selectAddressForOrder = address => {
  return {
    type: actionTypes.MENU_SELECT_ADDRESS_FOR_ORDER,
    address: address,
  }
}

const startRecentlyOrderRequest = () => {
  return {
    type: actionTypes.START_RECENTLY_ORDER_REQUEST,
  }
}

const finishRecentlyOrderRequest = () => {
  return {
    type: actionTypes.FINISH_RECENTLY_ORDER_REQUEST,
  }
}

export const logoutSuccess = () => {
  return {
    type: actionTypes.LOGOUT
  }
}

const requestSuccessListAddressToDelivery = listAddressToDelivery => {
  return {
    type: actionTypes.MENU_FETCHING_ADDRESS_SUCCESS,
    listAddressToDelivery: listAddressToDelivery,
  }
}

const fetchingMenuSuccess = data => {
  return {
    type: actionTypes.FETCHING_MENU_SUCCESS,
    businessCollection: data.businessCollection,
    businessDelivery: data.businessDelivery,
    businessPlatter: data.businessPlatter,
    popularDishDelivery: data.popularDishDelivery,
  }
}

const fetchingProductsSuccess = data => {
  return {
    type: actionTypes.FETCHING_PRODUCT_SUCCESS,
    products: data,
  }
}

const fetchingRecentlyOrderedSuccess = data => {
  return {
    type: actionTypes.FETCHING_RECENTLY_ORDERED_SUCCESS,
    recentlyOrdered: data,
  }
}

export const orderFeedbackPendingSuccess = pendingFeedback => {
  return {
    type: actionTypes.ORDER_FEEDBACK_PENDING_SUCCESS,
    pendingFeedback: pendingFeedback,
  }
}

export const orderFeedbackClear = () => {
  return {
    type: actionTypes.ORDER_FEEDBACK_CLEAR,
  }
}

const orderFeedbackSubmitted = () => {
  return {
    type: actionTypes.ORDER_FEEDBACK_SUBMITTED,
  }
}

const orderFeedbackSkipped = () => {
  return {
    type: actionTypes.ORDER_FEEDBACK_SKIPPED,
  }
}

const addProductToCart = payload => {
  return {
    type: actionTypes.ADD_PRODUCT_TO_CART,
    payload: payload,
  }
}

export const toggleMenuMobile = (status = null) => {
  return {
    type: actionTypes.TOGGLE_MENU_MOBILE,
    status: status
  }
}

export const toggleRestaurants = (status = null) => {
  return {
    type: actionTypes.TOGGLE_RESTAURANTS_MOBILE,
    status: status
  }
}

export const handleOrderToRepeat = (idOrder) => {
  return dispatch => {
    orderService
      .getOrder(idOrder)
      .then(response => {
        if (!response.restaurant.isOpen) {
          dispatch(errorHandling({
            showError: true,
            errorMessage: "Sorry, Restaurant for this order is already closed"
          }))
        } else if (!response.canOrder) {
          dispatch(errorHandling({
            showError: true,
            errorMessage: "Sorry, Restaurant for this order is not available today"
          }))
        } else {
          let productsLastOrder = response.orderItems.map(function (orderItem) {
            let productMap = {
              ...orderItem.product,
              mealOptions: orderItem.mealOptions ? orderItem.mealOptions : []
            }
            let price = 0
            if (orderItem.mealOptions) {
              price = orderItem.mealOptions.reduce((inicial, item) => {
                return inicial + item.product.price
              }, 0)
            }
            price = price + orderItem.product.price
            productMap.price = price
            return productMap
          })
          dispatch(addProductToCart({ product: productsLastOrder, business: response.restaurant }))
        }
      })
      .catch(err => {
        if (err.message) {
          dispatch(errorHandling({ showError: true, errorMessage: err.message }))
        }
      })
  }
}
export const errorHandling = (errorHandling) => {
  return {
    type: actionTypes.MENU_ERROR_HANDLING,
    errorHandling: errorHandling
  }
}

export const fetchingInvoiceInfo = (invoiceNumber) =>{
  return dispatch => {
    orderService
    .getInvoiceInfo(invoiceNumber)
    .then(data => {
      if(!!data.paymentDescription){
        dispatch(invoiceAlreadyPaid(data))
      }else{
        dispatch(fetchingInvoiceSuccess(data))
      }
    })
    .catch(err => {
       if (err.message) {
          dispatch(errorHandling({ showError: true, errorMessage: err.message }))
        }
    })
  }
}

const invoiceAlreadyPaid = payload => dispatch => {
  dispatch({
    type: actionTypes.INVOICE_FETCHING_SUCCESS,
    invoiceNumber : payload.invoiceNumber,
    currency : payload.currency,
    total : payload.total,
    descriptionSuccess : `Invoice ${payload.invoiceNumber} has already been paid.`
  })
  dispatch({
    type : actionTypes.CART_SET_INVOICE,
    payload : true
  })
  dispatch({
    type: actionTypes.CART_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: true,
  })
}

const fetchingInvoiceSuccess = payload => dispatch => {
  dispatch({
    type: actionTypes.INVOICE_FETCHING_SUCCESS,
    invoiceNumber : payload.invoiceNumber,
    currency : payload.currency,
    total : payload.total
  })
  dispatch({
    type : actionTypes.CART_SET_INVOICE,
    payload : true
  })
  dispatch( {
    type: actionTypes.TOGGLE_CART,
    status: true
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/Menu.js